import { type ReactNode } from 'react'
import {
  CARD_ACCENT_PRESETS,
  CARD_BANNER_PRESETS,
  CARD_DEFAULT_ACCENT_COLOR,
  CARD_DEFAULT_BANNER_COLOR,
  isNotEmpty,
  type CardColor,
} from '@terros/common'
import { ColorInput } from '@mantine/core'
import { useTranslation } from '@front/model'

type Props = {
  label: string
  value: CardColor | undefined
  onChange: (color: CardColor | undefined) => void
  variant: ColorPickerVariant
  description?: string
}

type ColorPickerVariant = 'accent' | 'banner'

const COLOR_PRESETS = new Map<ColorPickerVariant, string[]>([
  ['banner', CARD_BANNER_PRESETS],
  ['accent', CARD_ACCENT_PRESETS],
])

const DEFAULT_COLORS = new Map<ColorPickerVariant, string>([
  ['banner', CARD_DEFAULT_BANNER_COLOR],
  ['accent', CARD_DEFAULT_ACCENT_COLOR],
])

export const ColorSwatchPicker = ({ label, value, onChange, variant, description }: Props): ReactNode => {
  const { t } = useTranslation()

  return (
    <ColorInput
      aria-label={t('Custom {{label}}', { label })}
      closeOnColorSwatchClick
      withEyeDropper={false}
      description={description}
      label={label}
      placeholder='#000000'
      size='sm'
      swatches={COLOR_PRESETS.get(variant)}
      swatchesPerRow={4}
      value={value ?? DEFAULT_COLORS.get(variant)}
      onChange={(color) => onChange(isNotEmpty(color) ? color : undefined)}
    />
  )
}
